// @ngInject
function CustomerInvoiceApiService($q, $window, $cookies, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'customerinvoices';

    return {
        downloadAsPdf: downloadAsPdf,
        getAll: getAll,
        getAllUnboundInvoiceRow: getAllUnboundInvoiceRow,
        getById: ResourcesService.apiFactory.get(endpoint),
        setStatus: ResourcesService.apiFactory.get(endpoint + '/status'),
        saveCustomerInvoice: ResourcesService.apiFactory.save(endpoint + '/save')
    };

    function getAll(page, filter, pageSize) {
        var deferred = $q.defer();
        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (filter && !_.isEmpty(filter.term)) {
            params.searchTerm = filter.term;
        }
        if (filter && (filter.dueDateMin || filter.dueDateMax || filter.invoiceDateMin || filter.invoiceDateMax)) {
            params.dueDateMin = filter.dueDateMin;
            params.dueDateMax = filter.dueDateMax;
            params.invoiceDateMin = filter.invoiceDateMin;
            params.invoiceDateMax = filter.invoiceDateMax;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint, {params: params}).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getAllUnboundInvoiceRow(page, filter, pageSize) {
        var deferred = $q.defer();
        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter.term)) {
            params.searchTerm = filter.term;
        }
        if (filter.createdDateMin || filter.createdDateMax) {
            params.createdDateMin = filter.createdDateMin;
            params.createdDateMax = filter.createdDateMax;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/unboundrows', {params: params}).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }

    function downloadAsPdf(request) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/' + request.invoiceId + '/aspdf', { params: request, responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'invoice.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFileName(contentDisposition, defaultValue) {
        //"attachment; filename=PickingList36013.pdf"
        var filename = defaultValue;
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            var filenameRegex = /(?![=]{1})([\w\d\s]){1,}.pdf/ig;
            var matches = new RegExp(filenameRegex).exec(contentDisposition);
            if (matches != null && matches[0]) {
                filename = matches[0];
            }
        }
        return filename;
    }
}

angular
    .module('customerinvoices.api', [])
    .factory('CustomerInvoiceApiService', CustomerInvoiceApiService);
